import activityLog from "~/lang/nl-NL/activityLog.json";
import aiAssistant from "~/lang/nl-NL/ai-assistant.json";
import aiNotetaker from "~/lang/nl-NL/ai-notetaker.json";
import analytics from "~/lang/nl-NL/analytics";
import branding from "~/lang/nl-NL/branding";
import chat from "~/lang/nl-NL/chat";
import common from "~/lang/nl-NL/common";
import components from "~/lang/nl-NL/components.json";
import connections from "~/lang/nl-NL/connections.json";
import contacts from "~/lang/nl-NL/contacts.json";
import customViews from "~/lang/nl-NL/customViews.json";
import customerPortals from "~/lang/nl-NL/customerPortals.json";
import dataManagement from "~/lang/nl-NL/dataManagement";
import documents from "~/lang/nl-NL/documents";
import emails from "~/lang/nl-NL/emails.json";
import facilities from "~/lang/nl-NL/facilities";
import filters from "~/lang/nl-NL/filters";
import forms from "~/lang/nl-NL/forms";
import hierarchy from "~/lang/nl-NL/hierarchy.json";
import inventory from "~/lang/nl-NL/inventory";
import knowledgeBase from "~/lang/nl-NL/knowledgeBase.json";
import login from "~/lang/nl-NL/login";
import machines from "~/lang/nl-NL/machines";
import maintenanceDocuments from "~/lang/nl-NL/maintenanceDocuments";
import menus from "~/lang/nl-NL/menus";
import plans from "~/lang/nl-NL/plans";
import portal from "~/lang/nl-NL/portal.json";
import preventiveMaintenance from "~/lang/nl-NL/preventiveMaintenance";
import procedures from "~/lang/nl-NL/procedures";
import invoices from "~/lang/nl-NL/invoices.json";
import quotes from "~/lang/nl-NL/quotes.json";
import productionLines from "~/lang/nl-NL/productionLines.json";
import portalTickets from "~/lang/nl-NL/portalTickets.json";
import requests from "~/lang/nl-NL/requests.json";
import resourcePlanning from "~/lang/nl-NL/resourcePlanning";
import resources from "~/lang/nl-NL/resources.json";
import scheduling from "~/lang/nl-NL/scheduling.json";
import settings from "~/lang/nl-NL/settings";
import sharedAssets from "~/lang/nl-NL/sharedAssets.json";
import sharedDrive from "~/lang/nl-NL/sharedDrive.json";
import sidenav from "~/lang/nl-NL/sidenav.json";
import singlePortal from "~/lang/nl-NL/single-portal.json";
import teams from "~/lang/nl-NL/teams.json";
import supportTicketFormConfiguration from "~/lang/nl-NL/supportTicketFormConfiguration.json";
import supportTicketTypes from "~/lang/nl-NL/supportTicketTypes.json";
import supportTickets from "~/lang/nl-NL/supportTickets.json";
import tickets from "~/lang/nl-NL/tickets";
import users from "~/lang/nl-NL/users.json";
import workOrderFormConfiguration from "~/lang/nl-NL/workOrderFormConfiguration.json";
import workOrderTypes from "~/lang/nl-NL/workOrderTypes.json";
import LOCALES from "~/lang/locales";

export default {
  [LOCALES[4].locale]: {
    analytics,
    chat,
    common,
    connections,
    contacts,
    customViews,
    customerPortals,
    sidenav,
    dataManagement,
    documents,
    facilities,
    forms,
    inventory,
    login,
    machines,
    maintenanceDocuments,
    menus,
    preventiveMaintenance,
    resourcePlanning,
    settings,
    supportTickets,
    supportTicketFormConfiguration,
    supportTicketTypes,
    tickets,
    branding,
    procedures,
    invoices,
    quotes,
    filters,
    productionLines,
    knowledgeBase,
    components,
    teams,
    emails,
    workOrderTypes,
    workOrderFormConfiguration,
    activityLog,
    aiAssistant,
    aiNotetaker,
    hierarchy,
    scheduling,
    resources,
    sharedAssets,
    sharedDrive,
    singlePortal,
    requests,
    portalTickets,
    plans,
    portal,
    users,
  },
};
